import { createElement } from 'react';
const h3 = (props) => {
    const { title, ...others } = props;
    return createElement("h3", Object.assign({}, others), title);
};
export default h3;
